import update from 'immutability-helper';
import {
  GET_SECURITY_QUESTIONS_SUCCESS,
  GET_USER_SECURITY_SUCCESS,
  RESET_PASSWORD_SUCCESS,
  NAVIGATE_TO_CHANGE_SECURITY,
  NAVIGATE_TO_CHANGE_PASSWORD,
  NAVIGATE_TO_REVOKE_PRIVACY,
  NAVIGATE_TO_REVOKE_ORG_TERMS,
  NAVIGATE_TO_NATIONALITY,
  CHANGE_NATIONALITY_LANGUAGE_SUCCESS,
  TRUST_HANDBOOK_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
  securityQuestions: [],
  setPassword: false,
  setNationality: false,
  setTrustHandbook: false,
  userSecurity: {},
  isChangeSecurity: false,
  isChangePassword: false,
  isNationality: false,
  isPrivacy: false,
  isOrgTerms: false,
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SECURITY_QUESTIONS_SUCCESS:
      return update(state, {
        securityQuestions: { $set: action.payload.security_questions || [] },
        // setPassword: { $set: action.payload.setPassword || false },
        setNationality: { $set: action.payload.setNationality || false },
      });
    case CHANGE_NATIONALITY_LANGUAGE_SUCCESS:
      return update(state, {
        setTrustHandbook: { $set: action.payload.setTrustHandbook || false }
      });
    case TRUST_HANDBOOK_SUCCESS:
      return update(state, {
        setPassword: { $set: action.payload.setPassword || false },
      });
    case NAVIGATE_TO_CHANGE_SECURITY:
      return update(state, {
        isChangeSecurity: { $set: true },
        isChangePassword: { $set: false },
      });
    case NAVIGATE_TO_CHANGE_PASSWORD:
      return update(state, {
        isChangePassword: { $set: true },
        isChangeSecurity: { $set: false },
      });
    case NAVIGATE_TO_NATIONALITY:
      return update(state, {
        isChangePassword: { $set: true },
        isChangeSecurity: { $set: true },
        isNationality: { $set: false },
      });
    case NAVIGATE_TO_REVOKE_PRIVACY:
      return update(state, {
        isPrivacy: { $set: true },
        isOrgTerms: { $set: false },
      });
    case NAVIGATE_TO_REVOKE_ORG_TERMS:
      return update(state, {
        isPrivacy: { $set: false },
        isOrgTerms: { $set: true },
      });
    case RESET_PASSWORD_SUCCESS:
      return update(state, {
        setPassword: { $set: false },
      });
    case GET_USER_SECURITY_SUCCESS:
      return update(state, {
        userSecurity: { $set: action.payload.security || {} },
      });
    default:
      return state;
  }
};

export default accountReducer;
